import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFreeText } from '../utils/getFreeText';

export const fetchFreeText = createAsyncThunk<{ [key: string]: string }>('FETCH_FREE_TEXT', async () => {
  const text = await getFreeText();
  return text;
});
